import type { ScenarioModel } from '@/shared/generated'

import { entries, filter, flatMap, map, pipe } from 'lodash/fp'

import { uuid } from '@/shared/tools/utils'

export const prepareScenarioRuns = (
	scenarios: ScenarioModel[],
	values: Record<string, Record<string, string>>
) =>
	pipe(
		entries,
		flatMap(
			([global_pc_set_id, groupValues]: [string, Record<string, string>]) => {
				const combination_id = uuid()

				return pipe(
					entries,
					map(([optimization_group_id, scenario_id]) => {
						const scenario = scenarios.find((s) => s.id === scenario_id)
						if (!scenario) return null

						return {
							name: scenario.name,
							combination_id,
							global_pc_set_id,
							optimization_group_id,
							scenario_id,
							settings: scenario.settings || {},
						}
					}),
					filter(Boolean)
				)(groupValues)
			}
		)
	)(values)
